import { serialNumberVerify } from "../api/pocket_peace";

export const formatUtcToKoreanDate = (utcDateString) => {
  const date = new Date(utcDateString);

  // const kstDate = new Date(date.getTime() + 9 * 60 * 60 * 1000);
  const kstDate = new Date(date.getTime() * 60 * 60 * 1000);

  const year = kstDate.getFullYear();
  const month = String(kstDate.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작
  const day = String(kstDate.getDate()).padStart(2, "0");

  return `${year}.${month}.${day}`;
};

export const formatDate = (dateTimeString) => {
  const [datePart] = dateTimeString.split(" ");
  const [year, month, day] = datePart.split("-");
  return `${year}.${month}.${day}`;
};

export const checkSubscription = async () => {
  const verifyCheck = await serialNumberVerify();

  if (!verifyCheck) {
    window.history.back();
  }
};

export const parseJavaMapString = (mapString) => {
  if (typeof mapString !== "string" || !mapString) {
    console.warn(
      "formParams가 문자열이 아닙니다:",
      typeof mapString,
      mapString
    );
    return {};
  }

  try {
    let content = mapString.trim();
    if (content.startsWith("{") && content.endsWith("}")) {
      content = content.substring(1, content.length - 1);
    }

    if (!content.trim()) {
      return {};
    }

    const result = {};

    const pairs = content.split(/,\s*(?=[^=]+=)/);

    for (let pair of pairs) {
      const equalIndex = pair.indexOf("=");
      if (equalIndex > 0) {
        const key = pair.substring(0, equalIndex).trim();
        const value = pair.substring(equalIndex + 1).trim();
        result[key] = value;
      }
    }

    return result;
  } catch (error) {
    console.error("Map 문자열 파싱 실패:", error);
    return {};
  }
};

export const mapToQueryString = (paramsMap) => {
  return Object.entries(paramsMap)
    .map(([key, value]) => {
      const encodedValue = encodeURIComponent(value || "");
      return `${key}=${encodedValue}`;
    })
    .join("&");
};
